import React from 'react';
import { motion } from "motion/react";
import { ImagePlaceholder } from '@/features/home/utils';

// Mock data
type VenueCity = { name: string; clubCount: number; };

const cities: VenueCity[] = [
  { name: 'New York', clubCount: 42 },
  { name: 'London', clubCount: 38 },
  { name: 'Tokyo', clubCount: 51 },
  { name: 'Ibiza', clubCount: 25 },
];

const VenueShowcase: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
    hover: {
      y: -8,
      transition: {
        duration: 0.3,
      },
    },
  };


  return (
    <section id="venues" className="max-w-8xl mx-auto px-8 py-24">
      <motion.div 
        className="text-center mb-16"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-5xl font-serif font-medium text-white">Venues by City</h2>
        <p className="text-lg text-gray-400 mt-4 max-w-2xl mx-auto">Discover iconic nightlife destinations from around the globe.</p>
      </motion.div>
      <motion.div 
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {cities.map((city) => (
          <motion.div 
            key={city.name} 
            className="group relative overflow-hidden rounded-3xl cursor-pointer"
            variants={cardVariants}
            whileHover="hover"
          >
            <div className="aspect-[3/4]">
               <ImagePlaceholder label={`${city.name} Cityscape`} />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent transition-all duration-500 group-hover:from-black/90"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-1/3 group-hover:translate-y-0 transition-transform duration-500 ease-out">
              <h3 className="text-3xl font-serif font-medium">{city.name}</h3>
              <p className="text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">{city.clubCount} Premier Clubs</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default VenueShowcase;
